import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ProfileSection from "./routes/ProfileSection";
import TimeTableSection from "./routes/TimeTableSection";

export default store => ({
  path: ":student_id",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "./components"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "./modules/ProfileDetailsModule"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "StudentProgressSummary/modules/StudentProgressSummaryModule"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "TimetableConfiguration/modules/TimetableConfigurationModule"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "AdminTimetable/modules/TimetableModule"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "AttendanceSummary/modules/AttendanceSummaryModule"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "ManageFamily/modules/ManageFamilyModule"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "DPExamRegistration/modules/DPExamRegistrationModule"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "Course/routes/StudentDrive/modules/StudentDriveModule"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "BehaviourManagement/modules/BehaviourModule"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "ResetInviteAndSignInCodeModal/modules/ResetInviteAndSignInCodeModalModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
          importedModule5,
          importedModule6,
          importedModule7,
          importedModule8,
          importedModule9,
          importedModule10,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const progressSummaryReduce = importedModule2.default;
          const timeTableReducer = importedModule3.default;
          const adminTimetableReducer = importedModule4.default;
          const studentAttendanceReducer = importedModule5.default;
          const manageFamilyReducer = importedModule6.default;
          const dpExamRegistrationReducer = importedModule7.default;
          const StudentDriveReducer = importedModule8.default;
          const BehaviourManagementReducer = importedModule9.default;
          const resetInviteAndSignInCodeModalModule = importedModule10.default;

          injectReducer(store, {
            key: "profileSection",
            reducer,
          });
          injectReducer(store, {
            key: "studentProgressSummary",
            reducer: progressSummaryReduce,
          });
          injectReducer(store, {
            key: "timetableConfiguration",
            reducer: timeTableReducer,
          });
          injectReducer(store, {
            key: "timetableAdmin",
            reducer: adminTimetableReducer,
          });
          injectReducer(store, {
            key: "attendanceSummary",
            reducer: studentAttendanceReducer,
          });
          injectReducer(store, {
            key: "dpExamReg",
            reducer: dpExamRegistrationReducer,
          });
          injectReducer(store, {
            key: "manageFamily",
            reducer: manageFamilyReducer,
          });
          injectReducer(store, {
            key: "studentDrive",
            reducer: StudentDriveReducer,
          });
          injectReducer(store, {
            key: "behaviourManagement",
            reducer: BehaviourManagementReducer,
          });
          injectReducer(store, {
            key: "resetInviteAndSignInCodeModal",
            reducer: resetInviteAndSignInCodeModalModule,
          });

          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [TimeTableSection(store), ProfileSection(store)],
});
